import React, { useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import MenuBotones from "../../MenuBotones";

function BotonesDisponibles() {
  const { user } = useContext(AuthContext);

  const SECCIONES = [
    { section: null, items: [
      { label: "Disponible", icon: "fas fa-tasks", color: "#3b82f6", href: "/ListadoDisponible", desc: "Disponible general", enabled: !!user.menu_disponible },
      { label: "Disponible Vendedor", icon: "fas fa-tasks", color: "#14b8a6", href: "/ListadoDisponibleVendedor", desc: "Por vendedor", enabled: !!user.disponible_vendedores },
    ]},
  ];

  return (
    <MenuBotones
      titulo="Disponible"
      descripcion="Existencia disponible para venta"
      icono="fas fa-tasks"
      color="#3b82f6"
      secciones={SECCIONES}
    />
  );
}

export default BotonesDisponibles;
